// Core imports
import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

// Component Imports
import { Card, Col, Row } from 'antd';
import LiveChatUsageSection from './LiveChatUsageSection';
import LiveChatMissedChatsSection from './LiveChatMissedChatsSection';
import LiveChatResponseTimeSection from './LiveChatResponseTimeSection';
import LiveChatDurationSection from './LiveChatDurationSection';

// Misc imports
import { ANALYTICS_SECTIONS } from '../../constants/main';
import { useFetchLiveChatAnalyticsQuery } from '../../store/analytics/analyticsApi';
import { isEmptyArray } from '../../utils/is/isEmptyArray';

const AnalyticsLiveChatTab = ({
  requestParams,
  setIsLoading = () => false
}) => {

  const { data: liveChatAnalytics, isFetching: isFetchingLiveChatAnalytics, isUninitialized } = useFetchLiveChatAnalyticsQuery({ ...requestParams?.[0] }, { skip: isEmptyArray(requestParams) });

  // Memoize loading state to prevent unnecessary re-renders
  const isLoading = useMemo(() =>
    isFetchingLiveChatAnalytics || isUninitialized,
  [isFetchingLiveChatAnalytics, isUninitialized]
  );

  useEffect(() => {
    setIsLoading(isLoading);

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  const renderLiveChatSection = () => {
    return (
      <Row gutter={[16, 16]} className="mb-5 hide-empty" id={`analytics-section_${ANALYTICS_SECTIONS.LIVECHAT.key}`}>
        <Col xs={24} md={12} xxl={6} id={`analytics-section_${ANALYTICS_SECTIONS.LIVECHAT.key}_${ANALYTICS_SECTIONS.LIVECHAT.subSections.USAGE.key}`}>
          <Card className="h-100">
            <LiveChatUsageSection
              data={liveChatAnalytics?.usage}
              sectionTitle={t('Usage')}
              seriesName="LiveChats"
              isLoading={isLoading}
            />
          </Card>
        </Col>

        <Col xs={24} md={12} xxl={6} id={`analytics-section_${ANALYTICS_SECTIONS.LIVECHAT.key}_${ANALYTICS_SECTIONS.LIVECHAT.subSections.MISSED_CHATS.key}`}>
          <Card className="h-100">
            <LiveChatMissedChatsSection
              data={liveChatAnalytics?.missedChats}
              sectionTitle={t('Missed Chats')}
              isLoading={isLoading}
            />
          </Card>
        </Col>

        <Col xs={24} md={12} xxl={6} id={`analytics-section_${ANALYTICS_SECTIONS.LIVECHAT.key}_${ANALYTICS_SECTIONS.LIVECHAT.subSections.RESPONSE_TIME.key}`}>
          <Card className="h-100">
            <LiveChatResponseTimeSection
              data={liveChatAnalytics?.responseTimes}
              sectionTitle={t('Response Times')}
              isLoading={isLoading}
            />
          </Card>
        </Col>

        <Col xs={24} md={12} xxl={6} id={`analytics-section_${ANALYTICS_SECTIONS.LIVECHAT.key}_${ANALYTICS_SECTIONS.LIVECHAT.subSections.DURATION.key}`}>
          <Card className="h-100">
            <LiveChatDurationSection
              data={liveChatAnalytics?.duration}
              sectionTitle={t('Duration')}
              seriesName="Avg. Duration"
              isLoading={isLoading}
            />
          </Card>
        </Col>
      </Row>
    );
  };

  return (
    <Fragment>
      {renderLiveChatSection()}
    </Fragment>
  );
};

AnalyticsLiveChatTab.propTypes = {
  requestParams: PropTypes.array,
  setIsLoading: PropTypes.func
};
export default AnalyticsLiveChatTab;
